import { useCallback, RefObject, useLayoutEffect } from 'react';

export function useHandleFocus(focusElement: HTMLElement | RefObject<HTMLElement> | null, isOpen: boolean) {
  // Brings focus to an element either directly or via reference
  useLayoutEffect(() => {
    if (isOpen && focusElement){
      if (focusElement instanceof HTMLElement) {
        focusElement.focus();
      } else if (focusElement?.current) {
        focusElement.current.focus();
      }
    }
  },[isOpen, focusElement]);
}

// Returns a 'ref' that can be assigned to an element to bring focus
export function useRefHandleFocus(isOpen: boolean) {
  const setRef = useCallback(node => {
    if (node && isOpen){
        node.focus();
    }

  }, [isOpen]);

  return [setRef];
}
